var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "red-info_svg__red-info-path",
    fill: "#E2574C",
    d: "M10.5 0C4.701 0 0 4.701 0 10.5 0 16.3 4.701 21 10.5 21 16.3 21 21 16.3 21 10.5 21 4.701 16.3 0 10.5 0zm0 19.031A8.531 8.531 0 011.969 10.5 8.531 8.531 0 0110.5 1.969a8.531 8.531 0 018.531 8.531 8.531 8.531 0 01-8.531 8.531zm0-14.426c-.751 0-1.32.392-1.32 1.026v5.815c0 .634.569 1.025 1.32 1.025.734 0 1.322-.407 1.322-1.025V5.63c0-.619-.588-1.026-1.321-1.026zm0 9.176c-.722 0-1.31.588-1.31 1.311 0 .722.588 1.31 1.31 1.31a1.311 1.311 0 000-2.62z"
  })));
}

export default __webpack_public_path__ + "./fonts/red-info.65cd25276631c5eba48d01f30c3e9a0e.svg";
export { SvgRedInfo as ReactComponent };